<div class="padding-content orders-page">
    <div class="content-table-orders" *ngIf="idEvent">
        <app-orders-list [idEvent]="idEvent"></app-orders-list>
    </div>
</div>